import gql from 'graphql-tag'

const createAssenza = gql`
  mutation createAssenza($assenza: CreateAssenza!) {
    createAssenza(assenza: $assenza) {
      id
      utenteId
      utente {
        id
        nome
      }
      daDataOra
      aDataOra
      descrizione
      flagOccupato
    }
  }
`

export default createAssenza


// WEBPACK FOOTER //
// ./src/graphql/mutations/createAssenza.js